import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GroupResource } from '../domain/dtos/group-resource'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetGroupResourcesUseCase {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(groupId?: string): Promise<GroupResource[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/groupResource/getByGroup/pt`,
      body: { data: { groupId } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data?.result
    }

    throw new GeneralError()
  }
}
